import { Schema, z } from 'zod';

export type Channel = 'web' | 'mobile' | 'desktop';

export const ChannelSchema: Schema<Channel> = z.union([
  z.literal('web'),
  z.literal('mobile'),
  z.literal('desktop')
]);
